<template>
	<div class="about1">
		<div class="about1-c">
			<div class="about1-info">
				<div class="about1-info-h">Zhejiang Zhonggai Electric Power Engineering Co., Ltd</div>
				
				<p class="about1-info-f1 new-about1-info-f1">
				    <img src="../../../assets/newimg/202.jpg" align="left" width="46%" hspace="10" vspace="10">
						<p class="about1-info-f1-p about1-info-f1-p-en">
							<p>
								<span style="text-indent:28px;">
									Zhonggai Electric Power was founded in 2015 and is located in Hangzhou. It is a high-tech enterprise specializing in new energy fields such as wind power, photovoltaic power generation, and energy storage. The company integrates technology research and development, project development and investment, system design and integration, construction and operation, and focuses on investment and construction in five core sectors: photovoltaics, energy storage, decentralized wind power, electricity, and operation and maintenance. The company has professional qualifications such as Level 2 for general contracting of power engineering and Level 4 for installation, maintenance, and testing. It has gathered a large number of experienced and skilled talents in the wind power, photovoltaic, and power industries, and is one of the earliest new energy development and construction enterprises in China engaged in photovoltaic power generation and energy storage business.
								</span>
								<span style="text-indent:28px;">
									The company currently has a team of over 110 professionals in various fields, including more than 20 technical professionals with intermediate and senior professional titles, more than 10 engineering management personnel with national registered construction engineer practicing qualifications, and a team of over 60 skilled workers. The management team has a good background in the fields of electricity and new energy, and has rich management experience and professional capabilities; Having 12 patents, including 1 invention patent and 2 software copyrights; Has won honors such as "National Science and Technology Small and Medium sized Enterprise" in Zhejiang Province, "Outstanding Economic Contribution Award" in Gongshu District, Hangzhou, and "AAA Credit Enterprise"; Passed
									ISO9001 Quality Management System ISO14000 Environmental Management System ISO45001 occupational health and safety management system and SA8000 corporate social responsibility management system certification.
								</span>
								<span style="text-indent:28px;">
									The company adheres to the values of "customer win-win, collaborative responsibility, innovation and hard work, and pursuit of excellence", encourages innovation, precision and pragmatism, and at the same time, adheres to the concept of "customer first" to provide customers with professional and high-quality smart energy solutions; Our corporate mission is to empower technology and light up a green future, focusing on the research and innovation of smart energy technology, and committed to promoting the development of China's green economy.
								</span>
							</p>			
						</p>
				</p>
				
				<!-- <div class="about1-info-f">
					<img src="../../../assets/newimg/202.jpg" alt />
					<div class="about1-info-f-r">
						<div class="t">


						</div>
						<div class="t">
						    The company currently has a team of over 110 professionals in various fields, including more than 20 technical professionals with intermediate and senior professional titles, more than 10 engineering management personnel with national registered construction engineer practicing qualifications, and a team of over 60 skilled workers. The management team has a good background in the fields of electricity and new energy, and has rich management experience and professional capabilities; Having 12 patents, including 1 invention patent and 2 software copyrights; Has won honors such as "National Science and Technology Small and Medium sized Enterprise" in Zhejiang Province, "Outstanding Economic Contribution Award" in Gongshu District, Hangzhou, and "AAA Credit Enterprise"; Passed
						    ISO9001 Quality Management System ISO14000 Environmental Management System ISO45001 occupational health and safety management system and SA8000 corporate social responsibility management system certification.
						</div>
						<div class="t">
						    The company adheres to the values of "customer win-win, collaborative responsibility, innovation and hard work, and pursuit of excellence", encourages innovation, precision and pragmatism, and at the same time, adheres to the concept of "customer first" to provide customers with professional and high-quality smart energy solutions; Our corporate mission is to empower technology and light up a green future, focusing on the research and innovation of smart energy technology, and committed to promoting the development of China's green economy.
						</div> -->
						<!-- <div class="s">
							<div class="s-l">{{num1}}year</div>
							<div class="s-r">Established in 2015, located in Gongshu District, Hangzhou City</div>
						</div>
						<div class="s">
							<div class="s-l">{{num2}}+</div>
							<div class="s-r">Serve the whole country and regions</div>
						</div> -->
					<!-- </div>
				</div> -->
			</div>
		</div>
		<div class="about1-c1">
			<img class="about-bgimg" src="../../../../public/about/about-2.png" alt />
			<div class="about1-c1-c">
				<div class="about1-c1-header">
					<div class="h">
						<div>Team</div>
					</div>
					<div class="f"></div>
				</div>
				<div class="about1-c1-c1">{{num3}}+</div>
				<div class="about1-c1-c2">A team of over 110 professionals from various fields</div>
				<div class="about1-c1-c3">The company has five major centers, namely "Market Development, Technical
					Quality, Engineering Management, Finance, and Comprehensive", and two business units, "Power and
					Operations".</div>
				<div class="about1-c1-c3">
					The management team has a strong background in the fields of electricity and new energy, with rich
					management experience and professional abilities;
				</div>

				<div class="about1-c1-c4">
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num4}}
								<span>Grand</span>
							</div>
							<div class="s">
								Market development, technical quality
								Engineering management, finance and finance
							</div>
						</div>
						<img src="../../../../public/about/about-3.png" alt />
					</div>
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num5}}
								<span>business</span>
							</div>
							<div class="s" style=" display: -webkit-box;-webkit-box-orient: vertical;
			              -webkit-line-clamp: 4;
			              overflow: hidden;
			              text-overflow: ellipsis;">Two business units, Power and Operations</div>
						</div>
						<img src="../../../../public/about/about-4.png" alt />
					</div>
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num6}}
								<span>name</span>
							</div>
							<div class="s" style="-webkit-box-orient: vertical;
			              -webkit-line-clamp: 4;
			              overflow: hidden;
			              text-overflow: ellipsis; ">
								Having intermediate and senior professional titles
								Professional technical talents
							</div>
						</div>
						<img src="../../../../public/about/about-5.png" alt />
					</div>
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num7}}
								<span class="jia">+</span>
								<span>name</span>
							</div>
							<div class="s" style="-webkit-box-orient: vertical;
			              -webkit-line-clamp: 4;
			              overflow: hidden;
			              text-overflow: ellipsis; ">
								Technician team
							</div>
						</div>
						<img src="../../../../public/about/about-6.png" alt />
					</div>
					<div class="item">
						<div class="item-t">
							<div class="t">
								{{num8}}
								<span class="jia">+</span>
								<span>name</span>
							</div>
							<div class="s">The National Registered Constructor Practicing Qualification
								Engineering management personnel</div>
						</div>
						<img src="../../../../public/about/about-7.png" alt />
					</div>
				</div>
			</div>
		</div>
		
		<div class="mobile-about1-c2">
			<div class="mobile-abount1c2-title">development history</div>
			<swiper v-if="timelineData.length > 0" class="swiper-container"
				:style="{height:'440px !important',width:'100%;'}" @swiper="onSwiper" @slideChange="onSlideChange"
				:modules="modules" :pagination="{ clickable: true }"  :direction='horizontal' :navigation="false" :loop="true">
				<swiper-slide class="banner" style="width: 100%; height: 100% !important;" v-for="(item, index) in timelineData" :key="index">
					<div class="about1-info-box-s-h">{{timelineData[index].year}}年</div>
					<div class="about1-info-box-s-s" v-for="(itemx, indexx) in timelineData[index].events"
						:key="indexx">
						<div class="about1-info-box-s-s-yuan en-mobile-about1-info-box-s-s-yuan"></div>
						<div class="about1-info-box-s-s-sec en-mobile-about1-info-box-s-s-sec">{{itemx}}</div>
					</div>
				</swiper-slide>
				<div class="pagination new-pagination">
					<div v-for="(item, index) in timelineData.length" :key="index" :class="cIndex == index?'sdiv':''"></div>
				</div>
			</swiper>
		</div>

		<div class="about1-c2">
			<img class="about1-info-bg" src="../../../assets/about/about-11.png" alt="" />
			<div class="about1-info">
				<!-- <div class="about1-info-h">发展历程</div> -->
		
				
				<div class="about1-info-box">
					<div class="about1-info-box-h">development history</div>
					<div class="about1-info-box-s">
						<div class="about1-info-box-s-h">{{timelineData[selectIndex].year}}year</div>
						<div class="about1-info-box-s-s" v-for="(item, index) in timelineData[selectIndex].events" :key="index">
							<div class="about1-info-box-s-s-yuan"></div> <div class="about1-info-box-s-s-sec">{{item}}</div>
						</div>
						
					</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b1" @click="tapIndex(0)">
					<div class="blinking-circle" :class="selectIndex==0?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[0].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b2" @click="tapIndex(1)">
					<div class="blinking-circle" :class="selectIndex==1?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[1].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b3" @click="tapIndex(2)">
					<div class="blinking-circle" :class="selectIndex==2?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[2].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b5" @click="tapIndex(3)">
					<div class="blinking-circle" :class="selectIndex==3?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[3].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b6" @click="tapIndex(4)">
					<div class="blinking-circle" :class="selectIndex==4?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t">{{timelineData[4].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b7" @click="tapIndex(5)">
					<div class="blinking-circle" :class="selectIndex==5?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[5].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b8" @click="tapIndex(6)">
					<div class="blinking-circle" :class="selectIndex==6?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[6].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b9" @click="tapIndex(7)">
					<div class="blinking-circle" :class="selectIndex==7?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[7].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b10" @click="tapIndex(8)">
					<div class="blinking-circle" :class="selectIndex==8?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[8].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b11" @click="tapIndex(9)">
					<div class="blinking-circle" :class="selectIndex==9?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[9].year}}</div>
				</div>
				<div class="blinking-circle-b blinking-circle-b12" @click="tapIndex(10)">
					<div class="blinking-circle" :class="selectIndex==10?'blinking-circle-s':''"></div>
					<div class="blinking-circle-b-t" style="">{{timelineData[10].year}}</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide
	} from 'swiper/vue';
	import {
		Navigation,
		Pagination,
		A11y,
		Autoplay
	} from 'swiper/modules';
	import 'swiper/css';
	import 'swiper/css/navigation';
	import 'swiper/css/pagination';
	import 'swiper/css/autoplay';
	
	export default {
		components: {
			Swiper,
			SwiperSlide,
		},
		props: {
			list: {
				type: Array,
				default: []
			},
			list1: {
				type: Array,
				default: []
			},

		},
		data() {
return {
	num1: 0,
	num2: 0,
	num3: 0,
	
	num4: 0,
	num5: 0,
	num6: 0,
	num7: 0,
	num8: 0,
	
	increment: 1, // 每次增加的数值
	numto1: 110,
	intervalId1: null,
	
	modules: [A11y, Autoplay],
	cIndex: 0,
	
				selectIndex:10,
				timelineData: [
				  {
				  		year: "2015",
				  		events: ["Hangzhou Zhonggai Decoration Engineering Co., Ltd. was established。"]
				  	},
				  	{
				  		year: "2016",
				  		events: [
				  			"Renamed as Hangzhou Zhonggai Electric Power Engineering Co., Ltd;",
				  			'Formally entering the distributed photovoltaic industry, undertaking the first 1MW distributed photovoltaic business of Hangzhou Weisheng Technology.'
				  		]
				  	},
				  	{
				  		year: "2017",
				  		events: [
				  			"Overcoming multiple technical challenges in the industry, we have completed the construction of the first 6MW BIPV distributed photovoltaic project for the world's top 500 Zhongda Yuantong Logistics Park. This project has been included in the innovation case list of Hangzhou City and has been listed as a demonstration project by the city association, national energy and other experts. We have also welcomed various experts to visit and learn from it multiple times;",
				  			'In the first year, 50MW of distributed business construction was achieved, including the construction of large-scale distributed photovoltaic projects such as Jiashi Industrial Park 4.5MW, Taizhou Huadi 5.5MW, and Olida Elevator 4.7MW.'
				  		]
				  	},
				  	{
				  		year: "2018",
				  		events: [
				  			"Hangzhou Zhonggai Electric Power Engineering Co., Ltd. has been renamed as Zhejiang Zhonggai Electric Power Engineering Co., Ltd;",
				  			'Enter the whitelist of Dayou Power System and undertake the business of Zhenzhong Substation 110;',
				  			'Accumulatively built and self owned various types of photovoltaic power stations exceeding 200MW, while entering the EPC business.'
				  		]
				  	},
				  	{
				  		year: "2019",
				  		events: [
				  			"Successfully passed ISO9000 and ISO14000 system certifications, and gradually improved internal management;",
				  			'Signed a strategic cooperation agreement with Fuchunjiang to undertake the 5.3872MW photovoltaic project of Yongte Information and Yongte Cable.'
				  		]
				  	},
				  	{
				  		year: "2020",
				  		events: [
				  			"Establish strategic partnerships with Kaida and Yuanjing;",
				  			'Undertake the installation project of transformer and distribution for the Wenzhou Ruian to Cangnan (Zhejiang Fujian border) section of the Ningbo Taizhou Wenzhou Expressway double track.',
				  		]
				  	},
				  	
				  	{
				  		year: "2021",
				  		events: [
				  			"Establishing strategic partnerships with Jiangsu Tiandian and Fuchunjiang Group;",
				  			'Undertake the 1.65MW project of the second batch of village level photovoltaic poverty alleviation power stations in Chengde County during the 13th Five Year Plan period.'
				  		]
				  	},
				  	
				  	{
				  		year: "2022",
				  		events: [
				  			"Awarded the title of National Science and Technology oriented Small and Medium sized Enterprise;",
				  			'The construction of the information platform includes the launch of Engineering Treasure, Supply Chain, and Kingdee system;',
				  			'Undertaking the Hangzhou Steam Turbine 12MW rooftop distributed photovoltaic power generation project;',
				  			'Undertake the 10kV power distribution project of Guangdong Shuanglin Biotechnology Co., Ltd.'
				  		]
				  	},
				  	
				  	{
				  		year: "2023",
				  		events: [
				  			"Received the Outstanding Economic Contribution Award in Gongshu District;",
				  			'The order business has achieved a leapfrog breakthrough, with a team of over 50 members;',
				  			'EPC installed capacity exceeds 100 megawatts;',
				  			'The first undertaking of a 100 meter high-rise photovoltaic project and the first innovative application of perovskite modules (Yuhang District Government 1.2MW Photovoltaic Power Station);',
				  			'The first innovative application of flexible module photovoltaic project in tunnels (Yunxi Tunnel 236.25kWp photovoltaic project).'
				  		]
				  	},					
				  	{
				  		year: "2024",
				  		events: [
				  			'In the strategic adjustment year of "setting strategies, adjusting institutions, strengthening foundations, and seeking development", three major business and five major sector strategies were established, and the Power Division and Operation and Maintenance Division were established;',
				  			"Establish strategic partnerships with Jiangsu Yueda, CRRC, and Guangdong Construction Engineering;",
				  			"Undertake the power distribution project of Shanghai Songjiang High speed Railway Station and the 6MW photovoltaic project of Taizhou National Expo Center;",
				  			"Undertake the EPC project of Fenkou Songjing Oil Tea 40WM Agricultural Photovoltaic Complementary Project."
				  		]
				  	},
				  	{
				  		year: "2025",
				  		events: [
				  			"Zhejiang Zhonggai Electric Power Engineering Co., Ltd. has been renamed as Zhejiang Zhonggai Electric Power Technology Co., Ltd"
				  		]
				  	},
				],

			};
		},
		created() {
			var that = this
			this.intervalId1 = setInterval(function(){
				
				if(that.num1 < 9) {
					that.num1++;
				}
				if(that.num2 < 20) {
					that.num2++;
				}
				
				if(that.num4 < 5) {
					that.num4++;
				}
				if(that.num5 < 2) {
					that.num5++;
				}
				if(that.num6 < 20) {
					that.num6++;
				}
				if(that.num7 < 60) {
					that.num7++;
				}
				if(that.num8 < 10) {
					that.num8++;
				}
				
				if (that.num3 < 110) {
					that.num3++;
				} else {
					clearInterval(that.intervalId1); // 达到目标值后清除定时器
				}
			}, 80);
			
		},
		mounted() {
			
		
		},
		beforeDestroy() {
			clearInterval(this.intervalId1); // 清除定时器，避免内存泄漏
			
		},
		methods: {
			tapIndex(index){
				this.selectIndex = index
			},
			
			onSwiper(e) {
			
			},
			onSlideChange(e) {
			
				this.cIndex = e.realIndex
				console.log('Active index:', this.cIndex);
			},
		}
	};
</script>

<style lang="scss">
	.en-mobile-about1-info-box-s-s-yuan{
		top:7px !important;
	}
	.en-mobile-about1-info-box-s-s-sec{
		line-height:24px !important;
	}
	
	@media screen and (min-width: 1200px) {
		.about1{
			.about1-c {
				.about1-info{
					.about1-info-f1{
						&.new-about1-info-f1{
							img{
								height:726px;
							}
						}
						p.about1-info-f1-p{
							&.about1-info-f1-p-en{
								width:54%;
								p{
									line-height:23px;
									padding-left:40px;
								}
							}
						}
					}
				}
			}
		}
		
		
	}
	// div {
	//   box-sizing: border-box;
	// }

	// .about1 {
	//   width: 100%;

	//   .about1-c {
	//     background-color: white;
	//     justify-content: center;

	//     .about1-info {
	//       .about1-info-h {
	//         color: #332c2b;
	//       }

	//       .about1-info-f {
	//         justify-content: space-between;
	//         align-items: center;

	//         .about1-info-f-r {
	//           .t {
	//             font-family: AlibabaPuHuiTi-Regular;
	//             font-weight: 400;
	//             color: #332c2b;
	//             letter-spacing: 0;
	//           }

	//           .s {
	//             justify-content: space-between;
	//             align-items: center;

	//             .s-l {
	//               color: #008d8e;
	//             }

	//             .s-r {
	//               color: #332c2b;
	//             }
	//           }
	//         }
	//       }
	//     }
	//   }

	//   .about1-c1 {
	//     justify-content: center;
	//     position: relative;

	//     .about-bgimg {
	//       position: absolute;
	//       z-index: 1;
	//     }

	//     .about1-c1-c {
	//       position: relative;
	//       z-index: 3;

	//       .about1-c1-header {
	//         .h {
	//           div {
	//             color: white;
	//           }
	//         }
	//       }

	//       .about1-c1-c1 {
	//         color: #fff;
	//       }

	//       .about1-c1-c2 {
	//         color: #fff;
	//       }

	//       .about1-c1-c3 {
	//         color: #ffffff;
	//       }

	//       .about1-c1-c4 {
	//         display: flex;
	//         justify-content: space-between;

	//         .item {
	//           display: flex;
	//           flex-direction: column;
	//           justify-content: space-between;

	//           .t {
	//             color: #fff;
	//           }

	//           .s {
	//             color: #ffffff;
	//           }
	//         }
	//       }
	//     }
	//   }

	//   .about1-c2 {
	//     width: 100%;
	//     height: 850px;
	//     display: flex;
	//     padding: 120px 0 140px;
	//     background-color: white;

	//     .about1-info {
	//       width: 100%;
	//       padding: 0 60px;

	//       .about1-info-h {
	//         font-size: 40px;
	//         text-align: center;
	//       }

	//       .about1-info-f.timeline {
	//         margin-top: 60px;
	//         display: flex;
	//         align-items: center;
	//         justify-content: center;
	//         position: relative;
	//         height: 600px;

	//         .arrow-left,
	//         .arrow-right {
	//           cursor: pointer;
	//           transition: all 0.3s ease;
	//           flex-shrink: 0;
	//           z-index: 2;

	//           &:hover {
	//             transform: scale(1.1);
	//             opacity: 0.8;
	//           }

	//           &:active {
	//             transform: scale(0.95);
	//           }
	//         }

	//         .timeline-container {
	//           width: calc(100% - 100px);
	//           margin: 0 20px;
	//           overflow: hidden;

	//           .timeline-wrapper {
	//             transition: transform 0.5s ease;

	//             .timeline-ruler {
	//               display: flex;
	//               padding: 40px 0;
	//               position: relative;
	//               padding-bottom: 0;

	//               &::before {
	//                 content: "";
	//                 position: absolute;
	//                 bottom: 0;
	//                 left: 0;
	//                 width: calc(300px * 6);
	//                 height: 2px;
	//                 background: #ddd;
	//                 z-index: 1;
	//               }

	//               .timeline-item {
	//                 min-width: 300px;
	//                 position: relative;
	//                 padding: 0 30px;

	//                 .year-marker {
	//                   position: relative;
	//                   height: 300px;

	//                   .ruler-line {
	//                     position: absolute;
	//                     bottom: 0;
	//                     left: 0;
	//                     width: 100%;
	//                     display: flex;
	//                     justify-content: space-between;
	//                     align-items: flex-end;

	//                     .tick-mark {
	//                       width: 3px;
	//                       height: 30px;
	//                       background: #ddd;
	//                       position: relative;
	//                       z-index: 2;
	//                       transition: height 0.3s ease;

	//                       .event-dot {
	//                         position: absolute;
	//                         top: 0;
	//                         left: 50%;
	//                         transform: translateX(-50%);
	//                         width: 12px;
	//                         height: 12px;
	//                         border-radius: 50%;
	//                         background: #fff;
	//                         border: 2px solid #008d8e;
	//                         z-index: 3;
	//                       }
	//                     }

	//                     .tick-mark-small {
	//                       width: 1px;
	//                       height: 15px;
	//                       background: #ddd;
	//                       opacity: 0.5;
	//                       position: relative;
	//                       z-index: 2;
	//                     }
	//                   }

	//                   .events-container {
	//                     position: absolute;
	//                     left: 0;
	//                     bottom: 60px;
	//                     width: 100%;

	//                     .year {
	//                       position: relative;
	//                       left: 7px;
	//                       color: #008d8e;
	//                       font-size: 20px;
	//                       font-weight: bold;
	//                       margin-bottom: 15px;
	//                     }

	//                     .event {
	//                       font-size: 14px;
	//                       color: #666;
	//                       margin: 8px 0;
	//                       line-height: 1.6;
	//                       text-align: left;
	//                       border-radius: 4px;
	//                       margin-left: 10px;
	//                       padding-left: 7px;
	//                     }
	//                   }
	//                 }
	//               }
	//             }
	//           }
	//         }
	//       }
	//     }
	//   }
	// }

	// @media screen and (min-width: 1200px) {
	//   .about1 {
	//     width: 100%;

	//     .about1-c {
	//       width: 100%;
	//       display: flex;
	//       padding: 120px 0 120px;

	//       .about1-info {
	//         width: 1200px;

	//         .about1-info-h {
	//           font-size: 40px;
	//         }

	//         .about1-info-f {
	//           width: 100%;
	//           margin-top: 55px;
	//           display: flex;

	//           img {
	//             width: 700px;
	//             height: 495px;
	//           }

	//           .about1-info-f-r {
	//             margin-left: 30px;
	//             width: calc(100% - 420px);

	//             .t {
	//               font-size: 16px;
	//               color: #332c2b;
	//               line-height: 28px;
	//             }

	//             .s {
	//               margin-top: 13px;
	//               height: 106px;
	//               border-bottom: 1px solid #f1f1f1;
	//               display: flex;

	// 			              -webkit-box-orient: vertical;
	// 			              -webkit-line-clamp: 3; /* 限制显示3行 */
	// 			              overflow: hidden; /* 隐藏超出部分 */
	// 			              text-overflow: ellipsis; 

	//               .s-l {
	//                 font-size: 40px;
	//               }

	//               .s-r {
	//                 font-size: 16px;
	//               }
	//             }
	//           }
	//         }
	//       }
	//     }

	//     .about1-c1 {
	//       width: 100%;
	//       display: flex;
	//       padding-top: 90px;

	//       .about-bgimg {
	//         width: 100%;
	//         height: 100%;
	//         top: 0;
	//         left: 0;
	//       }

	//       .about1-c1-c {
	//         width: 1200px;

	//         .about1-c1-header {
	//           width: 100%;

	//           .h {
	//             height: 100px;
	//             line-height: 100px;
	//             border-bottom: 1px solid #aaa;

	//             div {
	//               width: 170px;
	//               height: 100px;
	//               font-size: 40px;
	//               border-bottom: 2px solid white;
	//             }
	//           }
	//         }

	//         .about1-c1-c1 {
	//           margin-top: 56px;
	//           font-size: 50px;
	//         }

	//         .about1-c1-c2 {
	//           font-size: 18px;
	//         }

	//         .about1-c1-c3 {
	//           margin-top: 30px;
	//           font-size: 18px;
	//         }

	//         .about1-c1-c4 {
	//           margin-top: 80px;
	//           height: 304px;
	//           display: flex;

	//           .item {
	//             flex: 1;
	//             height: 304px;
	//             border-left: 1px solid #aaa;
	//             padding: 40px;

	//             .t {
	//               font-size: 56px;

	//               span {
	//                 font-size: 18px;
	//               }
	//             }

	//             .s {
	//               font-size: 16px;
	//             }

	//             img {
	//               margin-top: 49px;
	//               width: 48px;
	//               height: 48px;
	//             }
	//           }
	//         }
	//       }
	//     }

	//     .about1-c2 {
	//       width: 100%;
	//       height: 850px;
	//       display: flex;
	//       padding: 120px 0 140px;

	//       .about1-info {
	//         /* width: 1200px; */
	//         width: 100%;

	//         .about1-info-h {
	//           font-size: 40px;
	//         }
	//       }
	//     }
	//   }
	// }

	// @media screen and (max-width: 1200px) {
	//   .about1 {
	//     width: 100%;

	//     .about1-c {
	//       width: 100%;
	//       display: flex;
	//       padding: 80px 20px;

	//       .about1-info {
	//         width: 100%;

	//         .about1-info-h {
	//           font-size: 24px;
	//         }

	//         .about1-info-f {
	//           width: 100%;
	//           margin-top: 30px;
	//           display: flex;

	//           img {
	//             width: 60%;
	//             height: 300px;
	//           }

	//           .about1-info-f-r {
	//             margin-left: 20px;
	//             width: calc(40% - 20px);

	//             .t {
	//               font-size: 14px;
	//               color: #332c2b;
	//               line-height: 20px;
	//             }

	//             .s {
	//               margin-top: 11px;
	//               height: 80px;
	//               border-bottom: 1px solid #f1f1f1;
	//               display: flex;

	//               .s-l {
	//                 font-size: 30px;
	//               }

	//               .s-r {
	//                 font-size: 14px;
	//               }
	//             }
	//           }
	//         }
	//       }
	//     }

	//     .about1-c1 {
	//       width: 100%;
	//       display: flex;
	//       padding-top: 50px;

	//       .about-bgimg {
	//         width: 100%;
	//         height: 100%;
	//         top: 0;
	//         left: 0;
	//       }

	//       .about1-c1-c {
	//         width: 100%;
	//         padding: 0 30px;

	//         .about1-c1-header {
	//           width: 100%;

	//           .h {
	//             height: 80px;
	//             line-height: 80px;
	//             border-bottom: 1px solid #aaa;

	//             div {
	//               width: 120px;
	//               height: 80px;
	//               font-size: 30px;
	//               border-bottom: 2px solid white;
	//             }
	//           }
	//         }

	//         .about1-c1-c1 {
	//           margin-top: 40px;
	//           font-size: 24px;
	//         }

	//         .about1-c1-c2 {
	//           font-size: 16px;
	//         }

	//         .about1-c1-c3 {
	//           margin-top: 20px;
	//           font-size: 16px;
	//         }

	//         .about1-c1-c4 {
	//           margin-top: 60px;
	//           height: 220px;
	//           display: flex;

	//           .item {
	//             flex: 1;
	//             height: 220px;
	//             border-left: 1px solid #aaa;
	//             padding: 20px;

	//             .t {
	//               font-size: 32px;

	//               span {
	//                 font-size: 16px;
	//               }
	//             }

	//             .s {
	//               font-size: 14px;
	//             }

	//             img {
	//               margin-top: 20px;
	//               width: 30px;
	//               height: 30px;
	//             }
	//           }
	//         }
	//       }
	//     }

	//     .about1-c2 {
	//       width: 100%;
	//       height: 600px;
	//       display: flex;
	//       padding: 80px 0 80px;

	//       .about1-info {
	//         width: 100%;

	//         .about1-info-h {
	//           font-size: 24px;
	//         }
	//       }
	//     }
	//   }
	// }

	// @media screen and (max-width: 880px) {
	//   .about1 {
	//     width: 100%;

	//     .about1-c {
	//       width: 100%;
	//       display: flex;
	//       padding: 80px 20px;

	//       .about1-info {
	//         width: 100%;

	//         .about1-info-h {
	//           width: 100%;
	//           font-size: 24px;
	//         }

	//         .about1-info-f {
	//           width: 100%;
	//           margin-top: 30px;
	//           padding: 0 12px;
	//           display: flex;
	//           flex-direction: column;

	//           img {
	//             width: 100%;
	//             height: 300px;
	//           }

	//           .about1-info-f-r {
	//             margin-top: 12px;
	//             width: 100%;

	//             .t {
	//               font-size: 14px;
	//               color: #332c2b;
	//               line-height: 20px;
	//             }

	//             .s {
	//               margin-top: 11px;
	//               height: 40px;
	//               border-bottom: 1px solid #f1f1f1;
	//               display: flex;

	//               .s-l {
	//                 font-size: 16px;
	//               }

	//               .s-r {
	//                 font-size: 13px;
	//               }
	//             }
	//           }
	//         }
	//       }
	//     }

	//     .about1-c1 {
	//       display: none;
	//     }

	//     .about1-c2 {
	//       width: 100%;
	//       height: 600px;
	//       display: flex;
	//       padding: 80px 0 80px;

	//       .about1-info {
	//         width: 100%;

	//         .about1-info-h {
	//           font-size: 24px;
	//         }
	//       }
	//     }
	//     .about1-c1-c4 {
	//       margin-top: 40px;
	//       height: 220px;
	//       display: flex;

	//       .item {
	//         padding: 12px;
	//       }
	//     }
	//   }
	// }
	// .icon{
	// 	display: inline-block;
	//     width: 6px;
	//     position: relative;
	//     height: 6px;
	//     background: rgb(0, 141, 142);
	//     border-radius: 50%;
	//     top: -1px;
	// }
</style>